import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ClienteLogin, UsuarioVamTit } from '../../login/cliente_login';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { correctHeight, detectBody, smoothlyMenu } from "../../../app.helpers";
import { SessionStorageService } from "ngx-webstorage";
import { VamTitularesService } from './vam-titulares.service';
import { VamTitularEntity } from './entities/vam_titulares_entity';
import { ConsultarUsuarioVAM } from '../../../components/common/utils/consultarUsuarioVAM';

const swal = require("sweetalert2");


declare var jQuery: any;

@Component({
    selector: 'vamTittular',
    providers: [VamTitularesService],
    templateUrl: 'vam-titulares.template.html',
    styleUrls: ["vam-titulares.style.css"]

})
export class vamTitulares  implements OnInit {
    usuario: ClienteLogin;
    usuarioVam: UsuarioVamTit;
    vamTitular:VamTitularEntity;
    constructor(
        private vamTitularesService: VamTitularesService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        private sesionStorageService: SessionStorageService,
        private consultarVAM: ConsultarUsuarioVAM
    ) {

    }

    ngOnInit(): void {
            /*correctHeight();
        detectBody();*/

        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {
                this.consultarVAM.iniciarUsuarioVAM();
                this.vamTitular = new VamTitularEntity();
                    this.vamTitularesService.ConsultarDatosVamTitular().subscribe(
                    datosTitular => {
                    this.vamTitular = datosTitular;

                    },
                    error => { this.handleError.redirectUrl(error); });
            }
        }
    }

    actualizarClienteVamTitular(): void {
      this.usuarioVam = jQuery.parseJSON(this.sesionStorageService.retrieve("uservam"));
      this.vamTitular.uniCod=this.usuarioVam.CodigoUnidad;
      this.vamTitularesService.ActualizarVamTitular(this.vamTitular).subscribe(
          datosClienteIndividual => {
              if (datosClienteIndividual) {
                  swal({
                      title: 'Datos actualizados',
                      text: "Su información ha sido actualizada satisfactoriamente",
                      type: 'success'
                  });
              }
          },
          error => { this.handleError.redirectUrl(error); });
  }


}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/vam/titulares/vam-titulares.component.ts